import { sharedInMemoryStorage } from '@sibly/sibly-sdk-browser';
import { Environment } from './types';

export const local: Environment = {
  name: 'local',
  env: 'local',
  mock: false,

  hades: {
    host: 'http://localhost:5000',
  },

  socket: {
    host: 'ws://localhost:5001',
  },

  wormhole: {
    // DEV -https://dev.azure.com/handsfreehealth/MIDAS/_workitems/edit/11797
    host: 'https://wormhole.sibly.care/prod',
    apiKey: '3vLJWZoJ4B3zIh7BYvf3was9iviXiFSE8vFQBwQh',
    source: 'Sibly.DashEvents-Dev'
  },

  fullStory: {
    orgId: '182P5Q',
    active: false,
  },

  sendbird: {
    appId: '65394BD2-243A-45BE-809C-2C8A5FD8B145',

    bot: {
      id: 'bot',
    },

    coach: {
      id: 'sibly',
      token: 'c84b7443745040555d889564418017282097e91b',
    },
  },

  userSnap: {
    apiKey: 'd7368b35-bd23-451c-93a3-d430984be9b0',
  },

  segment: {
    key: 'NGffpp9mD65ezVJC8x78UFZfAmp29VLW',
    track: true,
  },

  /// staging key
  split: {
    key: 'k24f71keue19amad2nbqmqrmt4uupqd0l3g5',
  },

  siblySDK: {
    Auth: {
      userPoolId: 'us-west-1_zE2AOgirg',
      userPoolClientId: '6f24uqruo57vvpqv521tvnr5c9',
    },
    transportOptions: {
      region: 'us-west-1',
      endpoint:
        'https://vfzvip76kjgu5m6uvl4rqy7xiq.appsync-api.us-west-1.amazonaws.com/graphql',
    },
    appId: 'a84a7a19-b6af-4388-850f-eab27dce8d58',
    storage: sharedInMemoryStorage,
  },

  sessionTimeouts: {
    inactivityDetectionTimeout: 30 * 60 * 1000, // 30 minutes
    logoutModalTimeout: 2 * 60 * 1000, // 2 minutes
  },

  nudgeChromeExtensionId: 'eajajgahcoojlanccbimhpfgffdbmonj',
};
